export default function AdminFiles() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">AdminFiles</h1>
      <div className="card">
        <p>Content for AdminFiles...</p>
      </div>
    </div>
  );
}
